const environment = {
    serverURL: "wss://api.easychatdesk.com/v1/customer"
    //serverURL: "ws://localhost:3001"
}

export default environment;